(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lgd-follow"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-lgd-floating]').forEach((widget) => {
    const topButton = widget.querySelector('[data-lgd-to-top]');
    let scheduled = false;
    const update = () => {
      topButton.hidden = window.scrollY < 500;
      scheduled = false;
    };
    window.addEventListener('scroll', () => {
      if (!scheduled) {
        scheduled = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
    topButton.addEventListener('click', () => {
      const disclosure = widget.querySelector('details');
      disclosure.open = false;
      window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
    update();
  });
  document.querySelectorAll('[data-lgd-follow]').forEach((disclosure) => {
    const toggle = disclosure.querySelector('summary');
    disclosure.addEventListener('toggle', () => toggle.setAttribute('aria-expanded', String(disclosure.open)));
    toggle.setAttribute('aria-expanded', String(disclosure.open));
    document.addEventListener('click', (event) => {
      if (disclosure.open && !disclosure.contains(event.target)) disclosure.open = false;
    });
    disclosure.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && disclosure.open) {
        disclosure.open = false;
        toggle.focus();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
